import React, { FC } from 'react';
import BaseTemplate from '../BaseTemplate';
import { Container } from 'react-bootstrap';
import LandscapeIndicatorBaseTemplate from '../../../templates/LandscapeIndicatorBaseTemplate';
import {
  TranslationOrganism,
  LandscapeIndicatorDescriptionOrganism,
} from '../../organisms';
import { LocalesLanguagesConstants } from '../../../locales/locales';
import { PromiseSettledResult } from '../../../utils/types/types';

interface LandscapeIndicatorDescriptionTemplateProps {
  setLanguage: React.Dispatch<React.SetStateAction<LocalesLanguagesConstants>>;
  selectedLanguage: LocalesLanguagesConstants;
  fromLanguage: LocalesLanguagesConstants;
  setFromLanguage: React.Dispatch<
    React.SetStateAction<LocalesLanguagesConstants>
  >;
  toLanguage: LocalesLanguagesConstants;
  setToLanguage: React.Dispatch<
    React.SetStateAction<LocalesLanguagesConstants>
  >;
  generateTranslation: () => Promise<void>;
  generateAllTranslations: () => Promise<PromiseSettledResult<void>[]>;
  description: string;
  setDescription: (description: string) => void;
  callbackFn: () => void;
}

const LandscapeIndicatorDescriptionTemplate: FC<
  LandscapeIndicatorDescriptionTemplateProps
> = ({
  setLanguage,
  selectedLanguage,
  fromLanguage,
  setFromLanguage,
  toLanguage,
  setToLanguage,
  generateTranslation,
  description,
  setDescription,
  callbackFn,
  generateAllTranslations,
}) => {
  return (
    <BaseTemplate>
      <Container>
        <LandscapeIndicatorBaseTemplate>
          <TranslationOrganism
            setLanguage={setLanguage}
            selectedLanguage={selectedLanguage}
            fromLanguage={fromLanguage}
            setFromLanguage={setFromLanguage}
            toLanguage={toLanguage}
            setToLanguage={setToLanguage}
            generateTranslation={generateTranslation}
            generateAllTranslations={generateAllTranslations}
          />
          <LandscapeIndicatorDescriptionOrganism
            description={description}
            setDescription={setDescription}
            callbackFn={callbackFn}
          />
        </LandscapeIndicatorBaseTemplate>
      </Container>
    </BaseTemplate>
  );
};

export default LandscapeIndicatorDescriptionTemplate;
